module.exports = __webpack_public_path__ + "img/result-true.a1fd75d1.svg";